export default __webpack_public_path__ + "static/media/Twitter.ba000dcf.svg";